import React, { useEffect, useState } from 'react';
import styles from '../../styles/ReporteAuditoriaStyles/ReporteAuditoria.module.css';
import { getModulosAuditoria, getPantallasAuditoria } from '../../api/auditoria';

/**
 * Filtros del Reporte de Auditoría.
 *
 * Props:
 *  filters: { nombre_usuario, modulo, pantalla, fecha_desde, fecha_hasta }
 *  onChange(key, value)
 *  onGenerate()
 *  onExport()
 *  loading: boolean
 *  hasData: boolean
 */
function FiltrosAuditoria({ filters, onChange, onGenerate, onExport, loading, hasData }) {
  const disabled = loading;
  const [modulos, setModulos] = useState([]);
  const [pantallas, setPantallas] = useState([]);
  const [loadingPantallas, setLoadingPantallas] = useState(false);

  // Cargar lista de módulos al montar
  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const data = await getModulosAuditoria();
        if (!cancel) setModulos(data?.modulos || []);
      } catch {
        if (!cancel) setModulos([]);
      }
    })();
    return () => { cancel = true; };
  }, []);

  // Recargar pantallas cada vez que cambie el módulo seleccionado
  useEffect(() => {
    let cancel = false;
    setLoadingPantallas(true);
    // Resetear pantalla seleccionada cuando cambia el módulo
    onChange('pantalla', '');
    (async () => {
      try {
        const data = await getPantallasAuditoria(filters.modulo || '');
        if (!cancel) setPantallas(data?.pantallas || []);
      } catch {
        if (!cancel) setPantallas([]);
      } finally {
        if (!cancel) setLoadingPantallas(false);
      }
    })();
    return () => { cancel = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.modulo]);

  return (
    <section className={styles.filtersSection}>
      <div className={styles.filtersRow}>
        {/* Nombre de usuario */}
        <div className={styles.filterGroupWide}>
          <label className={styles.filterLabel}>Nombre de Usuario</label>
          <input
            type="text"
            className={styles.filterInput}
            placeholder="Buscar por nombre…"
            value={filters.nombre_usuario || ''}
            onChange={(e) => onChange('nombre_usuario', e.target.value)}
            disabled={disabled}
          />
        </div>

        {/* Módulo (dropdown) */}
        <div className={styles.filterGroupWide}>
          <label className={styles.filterLabel}>Módulo</label>
          <select
            className={styles.filterInput}
            value={filters.modulo || ''}
            onChange={(e) => onChange('modulo', e.target.value)}
            disabled={disabled}
          >
            <option value="">Todos los módulos</option>
            {modulos.map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>

        {/* Pantalla (dropdown dependiente del módulo) */}
        <div className={styles.filterGroupWide}>
          <label className={styles.filterLabel}>Pantalla</label>
          <select
            className={styles.filterInput}
            value={filters.pantalla || ''}
            onChange={(e) => onChange('pantalla', e.target.value)}
            disabled={disabled || loadingPantallas}
          >
            <option value="">
              {loadingPantallas ? 'Cargando…' : 'Todas las pantallas'}
            </option>
            {pantallas.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </div>

        {/* Fecha desde */}
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Fecha Desde</label>
          <input
            type="date"
            className={styles.filterInput}
            value={filters.fecha_desde || ''}
            onChange={(e) => onChange('fecha_desde', e.target.value)}
            disabled={disabled}
          />
        </div>

        {/* Fecha hasta */}
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Fecha Hasta</label>
          <input
            type="date"
            className={styles.filterInput}
            value={filters.fecha_hasta || ''}
            max={new Date().toISOString().slice(0, 10)}
            onChange={(e) => onChange('fecha_hasta', e.target.value)}
            disabled={disabled}
          />
        </div>

        {/* Acciones */}
        <div className={styles.filterActions}>
          <button
            className={styles.btnGenerate}
            onClick={onGenerate}
            disabled={disabled}
          >
            {loading ? 'Consultando…' : 'Consultar'}
          </button>
          <button
            className={styles.btnExport}
            onClick={onExport}
            disabled={disabled || !hasData}
          >
            Exportar XLS
          </button>
        </div>
      </div>
    </section>
  );
}

export default FiltrosAuditoria;
